export default "/images/sonderjysk.webp?71d79566eb3592cbca787419f05c500c";